import { AnbLoadingService } from '@anb/ng-ui';
import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { ROUTE } from '@core/models/route';
import { GetUserCodes } from '@core/ngrx/actions/afschotmelding.actions';
import { CoreService } from '@core/services/core.service';
import { RouteService } from '@core/services/route.service';
import { Store } from '@ngrx/store';
import { ENVIRONMENT } from 'environments/environment';
import { filter } from 'rxjs';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  readonly ROUTE = ROUTE;
  readonly logoutUrl = ENVIRONMENT.API_BASE_PATH + ENVIRONMENT.logoutPath;

  browserSupported = false;

  constructor(
    readonly routeService: RouteService,
    readonly loadingService: AnbLoadingService,
    private readonly router: Router,
    private readonly coreService: CoreService,
    readonly store: Store,
  ) {
    router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
      window.scroll(0, 0);
    });
    this.browserSupported = this.coreService.browserSupported();
  }
  ngOnInit(): void {
    this.store.dispatch(GetUserCodes());
  }
  redirectToHome() {
    this.router.navigate(this.routeService.getHomeRoute());
  }
}
